import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import { Text } from '@atlaskit/primitives/compiled';
import { ModalHeader, ModalTitle, ModalBody, ModalFooter } from '@atlaskit/modal-dialog';

import { useChoreographerAssets } from '@confluence/choreographer-services/entry-points/useChoreographerAssets.ts';

import { type Suggestion } from './types/RemoteObject.ts';

type ReviewContentSuggestionsModalProps = {
	suggestions: Suggestion[];
	onClose: () => void;
};

const i18n = defineMessages({
	newSuggestionsAvailable: {
		id: 'side-navigation.review-content-suggestions-modal.new-suggestions-available',
		defaultMessage: 'New suggestions available',
		description: 'Title of the modal that opens to review content suggestions',
	},
	reviewContentSuggestions: {
		id: 'side-navigation.review-content-suggestions-modal.review-content-suggestions',
		defaultMessage:
			'We found {count, plural, one {# item} other {# items}} from your connected apps that might belong here.',
		description: 'Description of the modal that opens to review content suggestions',
	},
	closeButtonText: {
		id: 'side-navigation.review-content-suggestions-modal.close-button-text',
		defaultMessage: 'Close',
		description: 'Text for the close button in the modal that opens to review content suggestions',
	},
});

export const ReviewContentSuggestionsModal = ({
	suggestions,
	onClose,
}: ReviewContentSuggestionsModalProps) => {
	const { formatMessage } = useIntl();
	const { Modal } = useChoreographerAssets();

	// TODO: Add content suggestions list
	return (
		<Modal onClose={onClose} width="x-large">
			<ModalHeader>
				<ModalTitle>{formatMessage(i18n.newSuggestionsAvailable)}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<Text>
					{formatMessage(i18n.reviewContentSuggestions, {
						count: suggestions.length,
					})}
				</Text>
			</ModalBody>
			<ModalFooter>
				<Button appearance="primary" onClick={onClose}>
					{formatMessage(i18n.closeButtonText)}
				</Button>
			</ModalFooter>
		</Modal>
	);
};
